import React from 'react';
import styles from './LandingPage.module.css';

export default function Faqs({ faqs = [], language = 'en' }) {
  if (!faqs.length) return null;

  const lang = String(language).toLowerCase();
  const eyebrow = lang === 'es' ? 'Preguntas frecuentes' : 'FAQ';
  const title = lang === 'es' ? '¿Tienes dudas?' : 'Common Questions';

  return (
    <section className={`${styles.section} ${styles.sectionAlt}`}>
      <div className={styles.container}>
        <header className={styles.sectionHeader}>
          <p className={styles.sectionEyebrow}>{eyebrow}</p>
          <h2 className={styles.sectionTitle}>{title}</h2>
        </header>
        <div className={styles.faqsList}>
          {faqs.map((faq, idx) => {
            const q = faq.question ?? faq.title ?? '';
            const a = faq.answer ?? faq.content ?? '';
            return (
              <details key={faq.id ?? idx} className={styles.faqItem}>
                <summary className={styles.faqQuestion}>
                  {q}
                  <span className={styles.faqIcon}>+</span>
                </summary>
                <div className={styles.faqAnswer}>
                  <div className={styles.faqAnswerInner}>{a}</div>
                </div>
              </details>
            );
          })}
        </div>
      </div>
    </section>
  );
}
